<template>
  <div>
    <router-link to="/baomingxuzhi">Process</router-link>
    <img id="home_img" style="max-width: 100%; max-height: 100%" src="http://public-img.51easymaster.com/8a11ad86-f398-4308-a675-7761338fc0c0.png"/>
  </div>
</template>

<script>
export default {
  name: 'Home',
  mounted: function () {
    console.log(document.getElementById('home_img').offsetHeight)
  }
}
</script>

<style scoped>
  a {
    width: 15%;
    height: 100%;
    position: absolute;
    margin: auto;
    /*top: 646px;*/
    left: 42.5%;
    opacity: 0;
    filter: Alpha(opacity=0); /* 不占据空间，可以点击 */
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue